import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  saveDiversityInfoToStore,
  submitDiversityDetails,
} from "../../store/buyerFormDataSlice";
import ContinueButton from "../../Registration/ContinueButton";

const SupplierDiversityObjectivesForm = ({ onNext }) => {
  const supplierDiversityDetails = useSelector(
    (state) => state.buyerFormData.supplierDiversity
  );
  const userId = useSelector((state) => state.auth.id);
  const dispatch = useDispatch();
  const [selectedGoals, setSelectedGoals] = useState(() => {
    const goals = supplierDiversityDetails.objectives;
    return Array.isArray(goals)
      ? goals
      : typeof goals === "string"
      ? [goals]
      : [];
  });

  const [otherGoal, setOtherGoal] = useState("");

  const diversityOptions = [
    "Increase spend with diverse suppliers year-over-year",
    "Meet specific supplier diversity spend targets (e.g., 15% of total procurement)",
    "Align supplier diversity with ESG or CSR reporting goals",
    "Expand access and opportunities for underrepresented suppliers (e.g., BIPOC, LGBTQ+, Women, Veteran-owned businesses)",
    "Develop long-term partnerships with diverse suppliers",
    "Integrate supplier diversity into RFP and procurement processes",
    "Comply with federal, state, or local supplier diversity requirements",
    "Foster innovation and competitiveness through a more inclusive supply chain",
    "Not sure / still developing our supplier diversity strategy",
    "Other",
  ];

  const handleCheckboxChange = (goal) => {
    setSelectedGoals((prev = []) =>
      Array.isArray(prev)
        ? prev.includes(goal)
          ? prev.filter((g) => g !== goal)
          : [...prev, goal]
        : [goal]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const supplierDiversityObjectives = {
      userId: userId,
      objectives: [...selectedGoals, otherGoal].filter(Boolean),
    };

    dispatch(submitDiversityDetails(supplierDiversityObjectives));
    dispatch(saveDiversityInfoToStore(supplierDiversityObjectives));
    onNext();
  };

  return (
    <section className="flex flex-col min-h-screen py-10 px-6">
      <header className="mb-14">
        <h3 className="text-xl font-medium text-[#7E7E7E] text-center">
          Step 4
        </h3>
        <h1 className="text-2xl font-semibold text-[#1D2639] text-center">
          Supplier Diversity Objectives
        </h1>
        <p className="text-base font-medium text-[#7E7E7E] text-center mt-2">
          Outline your organization’s supplier diversity goals to help us align
          you with suppliers that meet your inclusivity and procurement
          objectives. This allows us to connect you with suppliers that meet
          your specific diversity and inclusion initiatives.
        </p>
      </header>
      <span className="w-full text-[#1D2639] text-base mb-4 text-left font-semibold max-w-[572px]">
        What are your corporate responsibility goals regarding supplier
        diversity? (Select all that apply)
      </span>
      <form className="flex flex-col w-full" onSubmit={handleSubmit}>
        <fieldset className="mb-8 space-y-3 justify-start items-start">
          {diversityOptions.map((option) => (
            <div
              key={option}
              className="text-left"
            >
              <label className="flex items-start space-x-2 text-[#1D2639] text-[12px]">
                <input
                  type="checkbox"
                  value={option}
                  checked={
                    Array.isArray(selectedGoals) &&
                    selectedGoals.includes(option)
                  }
                  onChange={() => handleCheckboxChange(option)}
                  className="mt-1 w-3 h-3 text-blue-500 border-gray-300 rounded focus:ring-blue-500"
                />
                <span className="text-[#1D2739] text-base font-normal">
                  {option}
                </span>
              </label>
              {option === "Other" && selectedGoals.includes("Other") && (
                <input
                  type="text"
                  value={otherGoal}
                  onChange={(e) => setOtherGoal(e.target.value)}
                  className="w-full sm:w-[572px] h-12 p-3 bg-[#F9F9F9] rounded-lg border-2 border-gray-300 mt-2"
                  placeholder="Please specify"
                />
              )}
            </div>
          ))}
        </fieldset>
        <ContinueButton onClick={handleSubmit} label="Save and Continue" />
      </form>
    </section>
  );
};

export default SupplierDiversityObjectivesForm;
